import React from 'react';
import { formatIndianAmount, formatReceiptDate } from '../MoneyReceipt/MoneyReceiptReport';
import './ConfirmationVoucherTemplate.css';

const VoucherRow = ({ label, value, className = '' }) => (
    <div className={`row ${className}`.trim()}>
        <div className="left">{label}</div>
        <div className="value">{value}</div>
    </div>
);

const ConfirmationVoucherTemplate = ({ header, lineItems }) => {
    if (!header) return null;

    const confirmationId = header.ConfirmationId || '';
    const customerName = (header.CustomerName || '').replace(/\s+/g, ' ').trim();
    const mobile = header.Mobile || '';
    const voucherDate = formatReceiptDate(header.VoucherDate);
    const grandTotal = formatIndianAmount(header.GrandTotal);
    const totalReceived = formatIndianAmount(header.TotalReceived);
    const due = formatIndianAmount(header.Due);
    const items = lineItems || [];

    return (
        <div id="confirmation-voucher-print-root" className="voucher">
            <div className="header-title">CONFIRMATION</div>

            <div className="top-section">
                <div className="company">
                    <strong>Explore TouristHub Holidays LLP</strong>
                    <br />
                    <b>Corp Office:</b> 63 Ananda Palit Road, Kolkata-700150
                    <br />
                    <b>Registered Office:</b> Asutosh Bhawan, M N Roy Road,
                    <br />
                    Barendrapara, Kol-700149
                    <br />
                    <b>GSTIN:</b> 19AALFE8568J1ZM
                    <br />
                    <b>Ph:</b> +91 98300 17303 / +91 99037 38567
                    <br />
                    <b>E-Mail:</b> touristhubinfo@gmail.com
                    <br />
                    www.touristhubindia.com
                </div>

                <img
                    src={`${process.env.PUBLIC_URL}/eth_logo.png`}
                    className="logo"
                    alt="Explore TouristHub Holidays"
                />
            </div>

            <div className="line customer-info-divider" />

            <div className="two-column">
                <div>
                    <VoucherRow label="Confirmation ID :" value={confirmationId} />
                    <VoucherRow label="Name :" value={customerName} className="row-name" />
                    <VoucherRow label="Mobile :" value={mobile} />
                </div>

                <div>
                    <VoucherRow label="Date :" value={voucherDate} />
                </div>
            </div>

            <div className="line" />

            <table className="line-items-table">
                <thead>
                    <tr>
                        <th className="col-slno">Sl. No.</th>
                        <th className="col-description">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.SlNo}>
                            <td className="col-slno">{item.SlNo}</td>
                            <td className="col-description">{item.Description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="totals-section">
                <div className="totals-row">
                    <span className="totals-label">Grand Total :</span>
                    <span className="totals-value">{grandTotal}</span>
                </div>
                <div className="totals-row">
                    <span className="totals-label">Total Received :</span>
                    <span className="totals-value">{totalReceived}</span>
                </div>
                <div className="totals-row">
                    <span className="totals-label">Due :</span>
                    <span className="totals-value">{due}</span>
                </div>
            </div>

            <div className="thank">Thank You!</div>
        </div>
    );
};

export default ConfirmationVoucherTemplate;
